export default __webpack_public_path__ + "locales/sl/DeleteThirdPartyDialog.json?hash=cf15c8fd0bcc4e89ad7fae01e61c0a6a";